// Barramento simples para avisar a UI que uma requisição retornou 403 (sem permissão).
// O interceptor do httpclient chama notifyForbidden(); o ForbiddenDialog (montado em App.js) escuta.
const listeners = new Set();

export const subscribeForbidden = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const notifyForbidden = () => {
  listeners.forEach((listener) => listener());
};
